import { useEffect, useState, useRef } from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import css from './index.module.scss';
import AnimatedSection, { AnimatedGrid } from '../../../us/StatusA/Components/AnimatedSection';
import EcoVideo from 'eco-design/base/eco-video';

interface VideoSectionProps {
    /** 模块唯一标识，用于触发动画和ID */
    sectionId: string;
    /** 触发动画的元素选择器 */
    triggerSelector: string;
    /** 视频源地址 */
    videoSrc: string;
    /** 视频封面图地址 */
    posterSrc: string;
    /** 标题文字 */
    title: string | React.ReactNode;
    /** 描述文字 */
    desc?: string;
    /** 标签文字 */
    label?: string;
    /** 视频aria标签 */
    ariaLabel?: string;
    /** 动画触发钩子值（0-1） */
    triggerHook?: number;
    /** 是否加强蒙层 */
    maskEnhance?: boolean;
}

const VideoSection: React.FC<VideoSectionProps> = ({
    sectionId,
    triggerSelector,
    videoSrc,
    posterSrc,
    title,
    desc,
    label,
    ariaLabel = typeof title === 'string' ? title : undefined,
    triggerHook = 1,
    maskEnhance = false,
}) => {
    const [shouldLoadPoster, setShouldLoadPoster] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    // 使用 Intersection Observer 实现 poster 懒加载
    useEffect(() => {
        const videoElement = videoRef.current;
        if (!videoElement) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !shouldLoadPoster) {
                        setShouldLoadPoster(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                rootMargin: '50px', // 提前50px开始加载
                threshold: 0.1, // 当10%可见时触发
            },
        );

        observer.observe(videoElement);

        return () => {
            observer.disconnect();
        };
    }, [shouldLoadPoster]);

    // const [load, setLoad] = useState(false);
    // const [textEnter, setTextEnter] = useState(false);

    // useScrollAnimation({
    //     triggerSelector: `#${sectionId}`,
    //     onEnter: () => setTextEnter(true),
    // });

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         const dom = AniContainer.create({
    //             triggerElement: triggerSelector,
    //             triggerHook,
    //             onEnter: () => setLoad(true),
    //         });
    //         return () => {
    //             dom.destroy();
    //         };
    //     }
    // }, [triggerSelector, triggerHook]);

    return (
        <section
            className={`videoSection GtmModuleData-section ${css.section} ${sectionId}`}
            id={sectionId}
            data-section-id={sectionId}
            data-section-title={typeof title === 'string' ? title : ''}
        >
            <div className="eco-video">
                <EcoVideo pc={videoSrc} poster={shouldLoadPoster ? posterSrc : undefined} loop autoPlay />
                {/* <video
                    ref={videoRef}
                    // className="eco-video"
                    src={videoSrc}
                    autoPlay
                    loop
                    muted
                    preload="auto"
                    poster={shouldLoadPoster ? posterSrc : undefined}
                    width="100%"
                    height="100%"
                    playsInline
                    aria-label={ariaLabel}
                /> */}
                <div className={`mask ${maskEnhance ? 'mask-enhance' : ''}`}></div>
            </div>
            <div className={`info enter`}>
                <AnimatedGrid variant="fadeInUp" options={{ stagger: 0.2, delay: 100, threshold: 0.2 }}>
                    {label && <p className="lable">{label}</p>}
                    <p className="title">{title}</p>
                    {desc && <p className="desc">{desc}</p>}
                </AnimatedGrid>
            </div>
        </section>
    );
};

export default VideoSection;
